export default __webpack_public_path__ + "static/media/placeholder.com-logo1_637146769278368505.c1f45ef8.jpg";